// extracted by mini-css-extract-plugin
export default {"info__payment__link":"HistoryTransactions_info__payment__link__cxcpp"};